import {UserBadges} from '@app/web-player/users/user-badges';
import {PartialUserProfile} from '@app/web-player/users/user-profile';
import {slugifyString} from '@ui/utils/string/slugify-string';
import clsx from 'clsx';
import {useMemo} from 'react';
import {Link, LinkProps} from 'react-router';

interface UserProfileLinkProps extends Omit<LinkProps, 'to'> {
  user: {
    id: number | string;
    name: string;
    is_pro?: boolean;
    is_verified?: boolean;
    sngine_badges?: PartialUserProfile['sngine_badges'];
  };
  className?: string;
}
export function UserProfileLink({
  user,
  className,
  ...linkProps
}: UserProfileLinkProps) {
  const finalUri = useMemo(() => {
    return getUserProfileLink(user);
  }, [user]);

  return (
    <Link
      {...linkProps}
      className={clsx('hover:underline', className)}
      to={finalUri}
    >
      <span className="inline-flex max-w-full items-center gap-1 align-middle">
        <span className="min-w-0 truncate">{user.name}</span>
        <UserBadges user={user} size="sm" />
      </span>
    </Link>
  );
}

export function getUserProfileLink(user: {
  id: number | string;
  name: string;
}): string {
  return `/user/${user.id}/${slugifyString(user.name)}/tracks`;
}
